<div class="container-fluid p-0 d-flex justify-content-center align-items-center h-100 w-100">
  <div class="row flex-lg-nowrap mx-3 mx-sm-0 container-home justify-content-center w-100">
    @if (showContainerImg && !localStorageService?.getIsVip) {
    <div class="mx-0 px-0 d-none d-sm-none d-md-block d-lg-block col-lg-3"
      [ngClass]="{'bg-white order-1 rounded-left':showSearchPerson,'order-1':!showSearchPerson}">
      <div class="container-bg" [ngClass]="{'rounded-left w-100':showSearchPerson}">
        <div class="d-flex justify-content-center align-items-center h-100">
          @if (!showSearchPerson) {
          <div class="opacity-1">
            <h2>Bienvenidos a</h2>
            <h2>Data Maintenance</h2>
          </div>
          }
        </div>
      </div>
    </div>
    }
    <div class="mx-0 px-0"
      [ngClass]="{'order-1 col-lg-7':showSearchPerson && showContainerImg && !localStorageService?.getIsVip,'order-1 col-lg-12':(showSearchPerson && showContainerImg && localStorageService?.getIsVip) || !showContainerImg,'order-2 col-lg-6':!showSearchPerson && showContainerImg}">
      @if (!showSearchPerson) {
      <app-country-list (onCountrySelected)="selectCountry($event)"></app-country-list>
      }

      @if (showSearchPerson) {
      <section class="p-0 m-0 h-100">
        <div class="p-0 m-0 h-100">
          @switch (menuOption?.title) {
          @default {
          <app-menu-home></app-menu-home>
          }
          @case (OptionMenuApps.DM) {
          <div class="page-shell h-100">

            @if(!localStorageService?.getIsVip){
            <app-sidebar></app-sidebar>
            }

            <app-home-searcher class="w-100 h-100"></app-home-searcher>
          </div>

          }
          }
        </div>
      </section>
      }
    </div>
  </div>
</div>

<app-overlay-loading></app-overlay-loading>
